module.exports = __webpack_public_path__ + "img/breakfast_title--extra.17739896.png";